import axios from 'axios'
import api, { setAccessToken } from './client'
import type {
  LoginRequest,
  LoginResponse,
  ClaimVerifyRequest,
  ClaimVerifyResponse,
  ClaimCompleteRequest,
  ForgotPasswordRequest,
  ResetPasswordRequest,
  User,
} from '../types'

export async function login(credentials: LoginRequest): Promise<LoginResponse> {
  const { data } = await api.post<LoginResponse>('/auth/login', credentials)
  setAccessToken(data.accessToken)
  return data
}

export async function logout(): Promise<void> {
  await api.post('/auth/logout')
  setAccessToken(null)
}

export async function refreshToken(): Promise<string> {
  // Use raw axios (not the `api` instance) to avoid the 401 interceptor loop
  const { data } = await axios.post<{ accessToken: string }>('/api/v1/auth/refresh', {}, { withCredentials: true })
  setAccessToken(data.accessToken)
  return data.accessToken
}

export async function getMe(): Promise<User> {
  const { data } = await api.get<User>('/auth/me')
  return data
}

export async function claimVerify(req: ClaimVerifyRequest): Promise<ClaimVerifyResponse> {
  const { data } = await api.post<ClaimVerifyResponse>('/auth/claim/verify', req)
  return data
}

export async function claimComplete(req: ClaimCompleteRequest): Promise<void> {
  await api.post('/auth/claim/complete', req)
}

export async function forgotPassword(req: ForgotPasswordRequest): Promise<void> {
  await api.post('/auth/forgot', req)
}

export async function resetPassword(req: ResetPasswordRequest): Promise<void> {
  await api.post('/auth/reset', req)
}
